import { Box, Typography } from '@mui/material'
import React from 'react'
import { HBox } from '../elements/basic-elements'
import GlobeIcon from '../images/icons/globe-icon'
import { createEmptyArray } from '../utilities/array'

const HIGHEST_RANK = 3

interface ImpactScoreGlobesProps {
  rank?: number | null
  includeLabel?: boolean
}

const ImpactScoreGlobes = (props: ImpactScoreGlobesProps) => {
  const actingRank = props.rank != null ? props.rank : 0
  return (
    <HBox gap="5px" flexWrap={'wrap'}>
      {props.includeLabel && (
        <Typography
          variant="body2"
          color="textPrimary"
          whiteSpace={{ xs: 'nowrap', md: undefined }}
        >
          {' '}
          Impact Score:{' '}
        </Typography>
      )}
      <HBox alignItems="center">
        {createEmptyArray(actingRank).map((_, i) => (
          <GlobeIcon key={i} />
        ))}
        {createEmptyArray(HIGHEST_RANK - actingRank).map((_, i) => (
          <Box sx={{ opacity: 0.25 }} key={i}>
            <GlobeIcon />
          </Box>
        ))}
      </HBox>
    </HBox>
  )
}

export default ImpactScoreGlobes
